module.exports = __webpack_public_path__ + "img/otopack-150-inactive.e626f547.svg";